import type {
  AutomationEvent,
  LeadRecord,
  PropertyRecord,
  SourceObservation
} from '@growth-rings/fmos-schema';

export const demoProperties: PropertyRecord[] = [
  {
    id: 'property-maple-ridge',
    name: 'Maple Ridge',
    address: 'Waitsfield, Vermont',
    municipality: 'Waitsfield',
    region: 'Mad River Valley',
    coordinates: { latitude: 44.1887, longitude: -72.8232 },
    parcelId: 'Demo parcel · confirm before use',
    stage: 'raw_land',
    readiness: 72,
    openDecisions: 4,
    activeProjectCount: 1,
    updatedAt: new Date().toISOString()
  }
];

export const demoLeads: LeadRecord[] = [
  {
    id: 'lead-site-access',
    propertyId: 'property-maple-ridge',
    projectId: 'project-access',
    title: 'Driveway access and phased site preparation',
    location: 'Waitsfield, Vermont',
    trade: 'Excavation + site work',
    fitScore: 86,
    status: 'assigned',
    clientPermission: true,
    createdAt: new Date(Date.now() - 1000 * 60 * 70).toISOString()
  },
  {
    id: 'lead-restoration',
    propertyId: 'property-village-house',
    projectId: 'project-restoration',
    title: 'Existing-home envelope and restoration review',
    location: 'Morrisville, Vermont',
    trade: 'Design + build',
    fitScore: 72,
    status: 'qualified',
    clientPermission: true,
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 26).toISOString()
  }
];

export const demoObservations: SourceObservation[] = [
  {
    id: 'obs-parcel', propertyId: 'property-maple-ridge', category: 'parcel',
    label: 'Parcel context', value: 'Boundary source located; owner confirmation requested.',
    sourceName: 'Vermont Parcel Data', observedAt: new Date().toISOString(),
    verification: 'source_record', status: 'ready'
  },
  {
    id: 'obs-terrain', propertyId: 'property-maple-ridge', category: 'terrain',
    label: 'Terrain and access', value: 'Slope and contour review queued for the selected point.',
    sourceName: 'Vermont GIS / LiDAR', observedAt: new Date().toISOString(),
    verification: 'planning_observation', status: 'processing'
  },
  {
    id: 'obs-water', propertyId: 'property-maple-ridge', category: 'water',
    label: 'Water context', value: 'Nearby records provide context only; field siting remains open.',
    sourceName: 'Vermont ANR Atlas', observedAt: new Date().toISOString(),
    verification: 'source_record', status: 'ready'
  },
  {
    id: 'obs-municipal', propertyId: 'property-maple-ridge', category: 'municipal',
    label: 'Town plan and bylaws', value: 'Current adopted documents require human review.',
    sourceName: 'Municipal Planning Data Center', observedAt: new Date().toISOString(),
    verification: 'authority_record', status: 'review_required'
  },
  {
    id: 'obs-solar', propertyId: 'property-maple-ridge', category: 'solar',
    label: 'Helio Dome', value: 'Seasonal solar arc can be calculated after terrain horizon processing.',
    sourceName: 'FM.OS solar planning model', observedAt: new Date().toISOString(),
    verification: 'planning_observation', status: 'processing'
  }
];

export const demoEvents: AutomationEvent[] = [
  {
    id: 'event-1', eventType: 'lead.created', aggregateType: 'lead', aggregateId: 'lead-site-access',
    status: 'succeeded', attemptCount: 1, createdAt: new Date(Date.now() - 1000 * 60 * 68).toISOString(),
    completedAt: new Date(Date.now() - 1000 * 60 * 67).toISOString()
  },
  {
    id: 'event-2', eventType: 'property.enrichment.requested', aggregateType: 'property',
    aggregateId: 'property-maple-ridge', status: 'processing', attemptCount: 1,
    createdAt: new Date(Date.now() - 1000 * 60 * 6).toISOString()
  }
];
